export enum DocumentReferenceType {
    LOAD = 1,
    LORRY = 2,
    COMPANY = 3
}

export enum TicketCode {
    LORRY_RECEIPT = 1,
    POD = 2,
    SUPPORTING_DOC = 3,
    EWAY_BILL = 5,
    GOODS_INVOICE = 6,
    SHOP_IMAGE = 7,
    AADHAAR = 100,
    BUSINESS_DOCUMENTS = 200,
    PAN = 300,
    RC_VALIDATION = 400
}

export enum TicketStatus {
    PENDING = 0,
    APPROVED = 1,
    RESOLVING = 4,
    REJECTED = 999
}

export enum DocumentType {
    LORRY_RECEIPT = 1,
    POD = 2,
    SUPPORTING_DOC = 3,
    EWAY_BILL = 5,
    GOODS_INVOICE = 7,
    SHOP_IMAGE = 6,
    AADHAAR_FRONT = 100,
    AADHAAR_BACK = 101,
    AADHAAR_SELFIE = 102,
    GST_CERTIFICATE = 200,
    MSME_CERTIFICATE = 201,
    GUMASTA_LICENSE = 202,
    TRADE_LICENSE = 203,
    PAN = 300,
    RC_VALIDATION = 400,
    DRIVER_LICENSE = 600,
    DRIVER_AADHAAR = 602,
    LORRY_BODY = 800
}
